var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('v-button',{staticClass:"btn btn-primary",nativeOn:{"click":function($event){return _vm.createPostback()}}},[_vm._v("Erstellen")])],1),_vm._v(" "),_c('div',[_c('v-table',{attrs:{"url":"/api/v1/postback","attributes":[
        {
          attribute: 'id',
          name: 'Postback-ID'
        },
        {
          attribute: 'affiliate_id',
          name: 'Werbung-ID'
        },
        {
          attribute: 'trigger_event',
          name: 'Trigger Event'
        },
        {
          attribute: 'type',
          name: 'Type'
        },
        {
          name: 'Aktionen',
          type: 'PostbackActionCell'
        }
      ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Postbacks")])])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }